var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJulianaLogoTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 506,
    height: 200,
    viewBox: "0 0 506 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M76.879,96.852H321.9v2.99H76.879Zm0,0",
    transform: "translate(-76.879 -96.852)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M35,40.961h85.448v193.2H35Zm0,0",
    transform: "translate(-35 -40.961)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 86,
    height: 198,
    transform: "translate(-0.112 -0.128)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_490",
    "data-name": "Path 490",
    d: "M.039.961H85.385v193.2H.039Zm0,0",
    transform: "translate(-0.039 -0.961)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_486",
    "data-name": "Path 486",
    d: "M.246,1H85.054V193.637H.246Zm0,0",
    transform: "translate(-0.246 -1)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M77.423,96.035A13.022,13.022,0,0,0,72.5,93.31a18.107,18.107,0,0,0-5.715-.681,30.2,30.2,0,0,0-5.857.824c-.356.071-.682.163-1.027.264-.366.1-.742.213-1.119.336a28.034,28.034,0,0,0-3.467,1.332,31.587,31.587,0,0,0-9.609,6.966A46.953,46.953,0,0,0,41.852,107c-.386.529-.752,1.048-1.108,1.586-.387.539-.753,1.108-1.108,1.688-.387.6-.773,1.2-1.129,1.82a59.088,59.088,0,0,0-5.044,11.074,69.409,69.409,0,0,0-2.8,11.908,83.661,83.661,0,0,0-1.007,12.548v.01c.224-.244.447-.5.671-.753.112-.122.213-.254.315-.386a21.865,21.865,0,0,0,1.332-1.739c.336-.478.651-.976.956-1.5.061-.1.132-.244.193-.346.244-.417.488-.844.712-1.281.051-.112.1-.234.153-.336.244-.468.468-.956.681-1.444.041-.091.071-.183.1-.275a6.007,6.007,0,0,0,.254-.64c.356-2.583.824-5.156,1.383-7.718a73.077,73.077,0,0,1,2.461-8.714c.112-.295.2-.59.295-.875.376-.986.752-1.973,1.169-2.959a62.9,62.9,0,0,1,2.939-6.142c.813-1.464,1.668-2.908,2.583-4.291s1.881-2.756,2.959-4.057a35.92,35.92,0,0,1,3.457-3.691,27.44,27.44,0,0,1,4.047-3.112,20.5,20.5,0,0,1,2.41-1.332c.376-.183.742-.346,1.119-.519A22.351,22.351,0,0,1,65.912,93.9a12.089,12.089,0,0,1,3.356.458,13.052,13.052,0,0,1,1.576.539l1.495.62A19.678,19.678,0,0,1,75.2,97.093c.437.325.895.641,1.312,1.017a13.049,13.049,0,0,1,1.241,1.139,10.123,10.123,0,0,1,1.871,2.766c.244.5.437,1.027.651,1.525.193.529.356,1.047.519,1.556a37.371,37.371,0,0,1,1.281,6.366,38.624,38.624,0,0,1-.692,12.884,50.055,50.055,0,0,1-1.81,6.183,59.466,59.466,0,0,1-2.6,5.867c-.254.468-.5.956-.742,1.424L75.44,139.2c-.549.936-1.119,1.83-1.678,2.735l-.915,1.312c-.305.447-.59.885-.936,1.3-.671.844-1.3,1.7-2.034,2.491a42.449,42.449,0,0,1-9.721,8.349,44.567,44.567,0,0,1-11.714,5.094l-1.536.407c-.254.061-.519.132-.773.183l-.783.163-1.566.305c-.519.112-1.047.163-1.566.254l-1.576.234c-.549.061-1.088.112-1.637.142a19.832,19.832,0,0,1-3.295-.051l-1.088-.091-.112-1.1c-.224-2.349-.356-4.688-.4-7.047-.264.142-.519.295-.783.427-.03.01-.061.041-.092.051-1.068.549-2.146,1.068-3.254,1.546.112,1.23.244,2.451.4,3.671l.254,1.922-1.84-.59a26.6,26.6,0,0,1-5.613-2.552,1.664,1.664,0,0,1-.142-.1c-.427-.264-.854-.549-1.261-.834a25.9,25.9,0,0,1-2.339-1.881c-.305-.285-.59-.559-.885-.854a1.533,1.533,0,0,1-.183-.183,29.656,29.656,0,0,1-3.823-4.84,40.383,40.383,0,0,1-2.827-5.42l-.569-1.4c-.183-.468-.346-.956-.519-1.434-.346-.956-.651-1.922-.925-2.9a53.553,53.553,0,0,1-1.342-5.918,59.358,59.358,0,0,1-.722-12.081,69.423,69.423,0,0,1,1.6-11.958,64.689,64.689,0,0,1,3.61-11.521c.366-.936.824-1.84,1.241-2.756.234-.458.468-.895.691-1.352l.346-.671.376-.651a47.739,47.739,0,0,1,3.264-5.1,51.439,51.439,0,0,1,3.854-4.677,52.966,52.966,0,0,1,4.4-4.149l.814-.681.793.712a19.447,19.447,0,0,0,8.318,4.4,18.084,18.084,0,0,0,2.756.458c.376.041.732.061,1.108.081.285.01.569.02.864.02a27.825,27.825,0,0,0,4.82-.387c1.637-.244,3.244-.549,4.82-.945a25.826,25.826,0,0,0,4.545-1.586,16.189,16.189,0,0,0,2.074-1.119,11.108,11.108,0,0,0,1.281-.966c.193-.153.366-.295.549-.468.2-.183.387-.366.57-.549a10.4,10.4,0,0,0,2.257-2.99,4.391,4.391,0,0,0,.315-.956,3.14,3.14,0,0,0,.071-.925,5.238,5.238,0,0,0-.59-1.922,6.078,6.078,0,0,0-1.312-1.556,5.568,5.568,0,0,0-.692-.478v2a3.864,3.864,0,0,1,.7,1.576,3.369,3.369,0,0,1,.071,1.017,4.963,4.963,0,0,1-.163.895,4.284,4.284,0,0,1-.254.773l-.071.213-.1.183-.193.387v.01a7.922,7.922,0,0,1-1.108,1.495,7.63,7.63,0,0,1-.935.885,15.068,15.068,0,0,1-5.227,2.624,33.543,33.543,0,0,1-5.481,1.1,24.5,24.5,0,0,1-5.664.061c-.366-.041-.753-.112-1.129-.173-.091-.02-.193-.031-.285-.051-.264-.061-.549-.112-.813-.183-.193-.051-.4-.091-.61-.163a14.771,14.771,0,0,1-5.2-2.7,16.16,16.16,0,0,1-2.085-2.085l-.966-1.149,1.281-.793a45.558,45.558,0,0,1,7.565-3.671v-1.24a53.779,53.779,0,0,0-8.633,3.488l-1.129.58-.549-1.149a22.2,22.2,0,0,1-1.932-6.549c-.153-1.119-.244-2.217-.295-3.325s-.061-2.227-.03-3.335l.061-1.352,1.322.163a50.731,50.731,0,0,0,9.3.132c.63-.041,1.261-.1,1.891-.163.376-.041.732-.071,1.1-.122.559-.061,1.119-.122,1.688-.193l2.319-.336,2.308-.427a55.791,55.791,0,0,0,12.172-3.844c.366-.173.742-.336,1.1-.508a35.841,35.841,0,0,0,4.027-2.309,33.533,33.533,0,0,0,7-6.01c.488-.6.976-1.2,1.474-1.8.447-.63.895-1.24,1.342-1.881.4-.661.813-1.3,1.2-1.973.366-.671.722-1.363,1.037-2.064a18.878,18.878,0,0,0,1.952-8.735,13.074,13.074,0,0,0-.935-4.271,11.333,11.333,0,0,0-.987-1.952l-.295-.468-.325-.447c-.1-.142-.2-.285-.325-.437l-.356-.4a11.06,11.06,0,0,0-3.406-2.6,14.03,14.03,0,0,0-4.21-1.261,23.911,23.911,0,0,0-4.525-.183c-.163,0-.305.031-.458.031a7.453,7.453,0,0,0-.6,1.169,14.068,14.068,0,0,1,4.485.661,9.98,9.98,0,0,1,4.047,2.441,11.343,11.343,0,0,1,2.5,3.966l.03.071.01.081a20.846,20.846,0,0,1,.529,3.2,13.983,13.983,0,0,1-.081,3.325,19.827,19.827,0,0,1-1.963,6.172,32.982,32.982,0,0,1-3.366,5.328,32.567,32.567,0,0,1-4.23,4.627,32.066,32.066,0,0,1-3.61,2.807c-.376.254-.732.508-1.1.742-.112.071-.2.153-.3.214a37.746,37.746,0,0,1-5.583,2.807,45.44,45.44,0,0,1-9.02,2.532c-.163.051-.336.092-.519.132a26.371,26.371,0,0,1-3.061.468q-.534.061-1.1.092c-4.423.346-9.264.163-9.264.163-.63-.01-1.251-.081-1.861-.122l-1.261-.092.142-1.3A52.629,52.629,0,0,1,29.141,46.2a50.328,50.328,0,0,1,3.142-7.972,54.314,54.314,0,0,1,4.434-7.3,44.741,44.741,0,0,1,2.969-3.712c-.03-1.383-.081-2.654-.173-3.8a41.077,41.077,0,0,0-5.328,4.8,50.4,50.4,0,0,0-5.715,7.423,44.335,44.335,0,0,0-6.427,17.45l-.214,1.5-1.413-.5a29.252,29.252,0,0,1-8.155-4.322,24.341,24.341,0,0,1-6.162-7,28.588,28.588,0,0,1-3.468-8.623c-.153-.763-.305-1.536-.4-2.319-.061-.773-.173-1.556-.183-2.329-.051-.773-.01-1.566,0-2.339l.092-1.19c.03-.386.092-.773.153-1.159a25.907,25.907,0,0,1,3.02-8.826,33.528,33.528,0,0,1,5.633-7.322A26.823,26.823,0,0,1,18.6,3.439a29.847,29.847,0,0,1,7.332-2.207.1.1,0,0,0-.051-.041.492.492,0,0,0-.112-.071.745.745,0,0,0-.315-.041,28.25,28.25,0,0,0-9.162,2.43A28.738,28.738,0,0,0,12.129,5.9,30.085,30.085,0,0,0,8.407,8.98a24.806,24.806,0,0,0-3.132,3.712c-.244.336-.447.671-.661,1.017l-.325.508-.275.539c-.183.366-.376.722-.539,1.1s-.346.732-.508,1.108A29.1,29.1,0,0,0,.618,26.44a31.546,31.546,0,0,0,0,4.9,29.305,29.305,0,0,0,.742,4.83,25.521,25.521,0,0,0,3.956,8.786,26.893,26.893,0,0,0,3.1,3.681,25.175,25.175,0,0,0,3.691,3.04,30.6,30.6,0,0,0,8.633,4.037l.864.254-.02.956v.051c-.02,1.495.051,2.99.163,4.494q.091,1.114.214,2.257l.132,1.129c.041.356.112.7.163,1.058a23.677,23.677,0,0,0,3.3,8.043L26.192,75l-1.007.661a53.7,53.7,0,0,0-10.453,9.162,59.348,59.348,0,0,0-7.86,11.531,54.1,54.1,0,0,0-5.064,13.006c-.275,1.129-.468,2.268-.641,3.417s-.285,2.318-.386,3.488c-.214,2.349-.346,4.708-.366,7.067a70.138,70.138,0,0,0,.295,7.016,52.3,52.3,0,0,0,1.159,6.884,37.027,37.027,0,0,0,5.5,12.609,32,32,0,0,0,4.261,4.972l.224.224c.468.427.946.844,1.424,1.261a29.752,29.752,0,0,0,2.9,2.156c.376.244.752.478,1.129.712.122.081.254.132.386.213a31.248,31.248,0,0,0,5.837,2.6,39.39,39.39,0,0,0,6.7,1.485l.885.112.173.885a59.3,59.3,0,0,0,3.335,11.623,38.358,38.358,0,0,0,6.061,10.25,21.866,21.866,0,0,0,4.291,3.884,16.717,16.717,0,0,0,5.206,2.308,18.465,18.465,0,0,0,5.7.427c.478-.061,1-.081,1.373-.163a3.543,3.543,0,0,0,1.078-.376c.01-.01.03-.01.041-.03a20.015,20.015,0,0,1-2.918-.122,17.659,17.659,0,0,1-5.1-1.363,17.842,17.842,0,0,1-4.474-2.837,23.759,23.759,0,0,1-3.518-3.854,35.839,35.839,0,0,1-4.759-9.1,53.739,53.739,0,0,1-2.461-9.874l-.234-1.413,1.423-.021c1.017-.03,2.034-.061,3.041-.122.5-.031.986-.071,1.485-.122.478-.061,1-.132,1.485-.2a48.736,48.736,0,0,0,5.908-1.22,46.666,46.666,0,0,0,11.125-4.556,48.744,48.744,0,0,0,9.63-7.24c.742-.682,1.4-1.444,2.1-2.166.651-.762,1.342-1.515,1.952-2.318a45.715,45.715,0,0,0,3.467-4.972l.773-1.291.732-1.342.356-.671.336-.681.661-1.373c.4-.936.834-1.841,1.19-2.8l.539-1.423.5-1.424a51.632,51.632,0,0,0,2.6-11.867,32.255,32.255,0,0,0-.966-11.9C82.11,102.228,80.3,98.537,77.423,96.035Zm0,0",
    transform: "translate(-0.414 -1.077)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.508,
    y1: -0.009,
    x2: 2.508,
    y2: 3.548,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#c0a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#c1a369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#c2a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#c3a46b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c4a56b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#c5a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c6a76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#c7a76d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#c8a86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#c9a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#caa96f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#cbaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#ccab70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#cdac71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cead71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#cead72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#cfae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#d0af73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#d1af74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#d2b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d3b175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#d4b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d6b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#d7b477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d8b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#d9b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#dab679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#dbb779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#dcb87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddb87b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_494",
    "data-name": "Path 494",
    d: "M43,78H82.048v59.874H43Zm0,0",
    transform: "translate(-43 -78)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_493",
    "data-name": "Path 493",
    d: "M75.6,82.078a34.73,34.73,0,0,0-3.345,3.569,46.415,46.415,0,0,0-2.888,3.966c-.793,1.19-1.607,2.532-2.532,4.2a65.522,65.522,0,0,0-4.037,8.949c-.132.346-.234.712-.356,1.057-.224,1.9-.508,3.712-.824,5.44.061-.031.132-.041.193-.071-.061.03-.132.051-.193.081H61.6a58.249,58.249,0,0,1-2.512,9.487c-.01.02-.02.061-.041.1-.092.244-.183.457-.275.681-.142.376-.295.773-.458,1.129a2.585,2.585,0,0,1-.1.254c-.224.519-.468,1.027-.712,1.536-.061.122-.122.244-.173.366-.071.132-.153.254-.213.386-.173.336-.346.661-.529.966-.071.122-.132.254-.213.376-.325.549-.651,1.068-1,1.566-.437.63-.905,1.231-1.393,1.82-.112.132-.213.275-.315.387-.427.5-.864.966-1.322,1.424a.976.976,0,0,1-.183.173c-.153.163-.315.305-.478.468-.224.213-.447.417-.681.62-.071.051-.122.1-.193.153-.447.4-.925.783-1.4,1.139a2.053,2.053,0,0,1-.305.214c-.732.529-1.485,1.017-2.268,1.474.051.071.081.153.132.213-.041-.061-.112-.132-.142-.193a27.948,27.948,0,0,1-3.64,1.778A23.521,23.521,0,0,0,45.8,137.74c.8-.213,1.6-.456,2.38-.711-.03-.081-.03-.161-.061-.234a.982.982,0,0,1,.071.224c1.047-.336,2.054-.711,3.061-1.127.386-.143.762-.307,1.139-.479.407-.172.8-.346,1.18-.519.02,0,.03-.02.041-.02.559-.264,1.119-.529,1.657-.824.061-.03.112-.071.183-.1.376-.213.773-.427,1.149-.641.1-.061.214-.122.315-.173.122-.071.244-.142.376-.224.153-.092.315-.2.478-.295.244-.163.5-.315.752-.468s.468-.315.692-.468c.295-.2.579-.4.874-.6.519-.366,1.017-.742,1.525-1.129a45.8,45.8,0,0,0,16.29-25.33c.183-.732.356-1.495.529-2.278.071-.295.122-.59.183-.874.112-.488.2-.966.295-1.485.081-.387.142-.783.224-1.18s.132-.793.2-1.2c.081-.5.153-.986.234-1.485.03-.183.051-.386.081-.58.325-2.2.6-4.494.824-6.925v-.03c.081-.865.163-1.749.224-2.634v-.01c.132-1.769.254-3.579.346-5.46.041-.793.071-1.607.1-2.43-.579.315-1.159.63-1.718,1A37.251,37.251,0,0,0,75.6,82.078Zm0,0",
    transform: "translate(-43.188 -78.051)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 2.367,
    y1: 2.35,
    x2: 2.367,
    y2: 5.908,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#c0a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#c1a369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#c2a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#c3a46b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c4a56b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#c5a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c6a76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#c7a76d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#c8a86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#c9a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#caa96f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#cbaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#ccab70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#cdac71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cead71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#cead72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#cfae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#d0af73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#d1af74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#d2b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d3b175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#d4b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d6b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#d7b477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d8b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#d9b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#dab679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#dbb779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#dcb87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddb87b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_497",
    "data-name": "Path 497",
    d: "M50,61H73.429V89.635H50Zm0,0",
    transform: "translate(-50 -61)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_496",
    "data-name": "Path 496",
    d: "M55.124,65.414l-2.369.336c-.6.081-1.21.163-1.84.224V67.9H51c-.02,0-.061.01-.081.01V87.3a11.048,11.048,0,0,0,1.261.183,22.846,22.846,0,0,0,5.39-.051,31.682,31.682,0,0,0,5.3-1.057,13.505,13.505,0,0,0,4.81-2.41,7.567,7.567,0,0,0,1.688-1.942c0-.712.01-1.424.01-2.125V61.285a56.611,56.611,0,0,1-11.938,3.7Zm0,0",
    transform: "translate(-50.914 -61.285)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 5.794,
    y1: 1.086,
    x2: 5.794,
    y2: 4.643,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#c0a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#c1a369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#c2a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#c3a46b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c4a56b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#c5a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c6a76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#c7a76d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#c8a86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#c9a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#caaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#cbaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#ccab70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#cdac71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cead71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#cfad72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#cfae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#d0af73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#d1b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#d2b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d3b175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#d4b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d6b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#d7b477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d8b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#d9b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#dab679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#dbb779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#dcb87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddb97b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M50,71H70.826V99.635H50Zm0,0",
    transform: "translate(-50 -71)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M66.466,72.705a28.329,28.329,0,0,1-4.749,1.657,43.748,43.748,0,0,1-4.942.987,30.31,30.31,0,0,1-5.013.4c-.275,0-.57-.01-.844-.02V98.432c.051-.061.091-.142.142-.213a47.341,47.341,0,0,1,3.966-4.769,32.432,32.432,0,0,1,9.965-7.2A30.974,30.974,0,0,1,69,84.735c.142-4.3.254-8.867.315-13.657-.214.142-.407.305-.641.458A22.609,22.609,0,0,1,66.466,72.705Zm0,0",
    transform: "translate(-50.918 -71.078)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 5.809,
    y1: 3.43,
    x2: 5.809,
    y2: 6.989,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M28.844,96H63.092v15.619H28.844Zm0,0",
    transform: "translate(-28.844 -96)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 36,
    height: 16,
    transform: "translate(0.11 0.093)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M.844.719H33.221V14.467H.844Zm0,0",
    transform: "translate(-0.844 -0.719)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M.844,1H32.489V13.914H.844Zm0,0",
    transform: "translate(-0.844 -1)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M28.241,9.556C27,9.261,18.866,6.414,16.364,5.316c-.163-.071-.336-.153-.5-.214-.315-.153-.63-.285-.936-.417-.508-.224-1-.447-1.474-.661-1.82-.814-3.386-1.535-4.474-1.912A12.942,12.942,0,0,0,4.924,1.34a4.483,4.483,0,0,0-2.451.6A3.74,3.74,0,0,0,1,4.98c-.2,4.027,5.613,5.583,9.1,6.142.163.031.325.061.519.1.051.01.092.01.142.02.183.031.376.051.59.1h.031c.2.02.417.051.62.071a1.273,1.273,0,0,0,.193.031c.224.031.468.051.712.092h.051c.244.031.5.051.732.081a1.4,1.4,0,0,0,.2.031c.264.031.529.061.814.092h.01c.275.031.559.051.844.092a1.406,1.406,0,0,1,.2.031c.275.031.549.051.844.081.061,0,.112.01.163.01.234.031.468.041.7.071.092.01.173.01.264.02.285.03.559.061.834.081h.071c.264.03.519.051.783.071a1.691,1.691,0,0,1,.224.031c.559.051,1.1.092,1.617.142.071,0,.122.01.183.01.519.041,1.007.092,1.454.122a.346.346,0,0,1,.1.01c.224.02,2.512.2,2.532.214,2.115,0,4.169-.1,6.172-.285a31.925,31.925,0,0,1-3.346-2.766Zm0,0",
    transform: "translate(-0.994 -1.34)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 1.752,
    y1: 45.534,
    x2: 1.752,
    y2: 49.094,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M43,43h59.874V92.461H43Zm0,0",
    transform: "translate(-43 -43)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M71.2,44c-11.806,0-21.009-.193-27.395-.579v1.637a43.729,43.729,0,0,1,11.064,1.769,9.374,9.374,0,0,1,5.969,5.918A22.315,22.315,0,0,1,61.9,57.6c.061.427.1.885.153,1.332.092,1.047.153,2.176.2,3.386.01.549.02,1.119.031,1.688,0,.458.02.905.02,1.373v5.888a.958.958,0,0,0,.163-.041.794.794,0,0,1-.163.071V90.949a24.574,24.574,0,0,0,2.8-.437c.142-.041.295-.071.427-.122l.142-.041a44.335,44.335,0,0,0,8.8-2.461,38.325,38.325,0,0,0,5.41-2.715c.325-.193.61-.427.915-.62v-12.4c-.02,0-.061-.01-.091-.01a.252.252,0,0,1,.091.01v-6.8a44.366,44.366,0,0,1,1.119-11.541,11.307,11.307,0,0,1,.346-1.078.683.683,0,0,1,.061-.153,10.869,10.869,0,0,1,.488-1.1,11.959,11.959,0,0,1,.773-1.261,9.52,9.52,0,0,1,4.657-3.417A44.869,44.869,0,0,1,99.3,45.047V43.41C92.253,43.8,82.826,44,71.2,44Zm0,0",
    transform: "translate(-43.809 -43.41)",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 2.262,
    y1: -1.901,
    x2: 2.262,
    y2: 1.657,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(-296 -828)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 506,
    height: 200,
    transform: "translate(296 828)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131",
    transform: "translate(426.521 912.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_156",
    "data-name": "Group 156",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_155",
    "data-name": "Group 155",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M2.354,28.082A3.87,3.87,0,0,0,5.2,26.9a4.33,4.33,0,0,0,1.3-2.929V-12.39a3.307,3.307,0,0,0-1.261-2.6,4.181,4.181,0,0,0-2.888-1.1H1.541L1.5-16.742H20.536a28.62,28.62,0,0,0,4.352-.366,16.719,16.719,0,0,0,3.376-.813v8.216h-.651v-1.18a3.61,3.61,0,0,0-1.1-2.644,3.569,3.569,0,0,0-2.563-1.18H10.733V5.344H21.675a3.276,3.276,0,0,0,2.2-.976,3.013,3.013,0,0,0,.935-2.278V1.2h.651v10.25h-.651v-.976a3.024,3.024,0,0,0-.895-2.2A3.207,3.207,0,0,0,21.756,7.3H10.733V26.7h9.274q4.789,0,7.322-2.115a15.647,15.647,0,0,0,4.23-6.386h.651L28.468,28.732H1.5v-.651Zm0,0",
    transform: "translate(-1.5 17.922)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132",
    transform: "translate(482.837 912.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_159",
    "data-name": "Group 159",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1.616,25.913a24.256,24.256,0,0,1-.163-3.539,17.217,17.217,0,0,1,.976-5.491H3a10.929,10.929,0,0,0-.081,1.424,9.394,9.394,0,0,0,2.4,6.589A8.332,8.332,0,0,0,11.7,27.5a9.43,9.43,0,0,0,6.711-2.441,8.168,8.168,0,0,0,2.644-6.223,7.865,7.865,0,0,0-2.522-6.061L6.049,1.223a10.3,10.3,0,0,1-3.5-7.85A11.13,11.13,0,0,1,5.6-14.518a10.922,10.922,0,0,1,8.379-3.295,27.873,27.873,0,0,1,5.572.651h2.522v7.972h-.569a6.042,6.042,0,0,0-2.115-4.84,8.049,8.049,0,0,0-5.45-1.83,7.576,7.576,0,0,0-5.532,2.2A7.427,7.427,0,0,0,6.171-8.132a7.477,7.477,0,0,0,2.6,5.695L21.587,9.4a10.535,10.535,0,0,1,3.254,8.176,11.571,11.571,0,0,1-3.335,8.542,11.844,11.844,0,0,1-8.826,3.335,22.844,22.844,0,0,1-6.061-.895A10.764,10.764,0,0,1,1.616,25.913Zm0,0",
    transform: "translate(-1.453 17.812)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133",
    transform: "translate(530.235 912.593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161",
    "data-name": "Group 161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M37.474-10.941a3.71,3.71,0,0,0-1.139-2.685,3.817,3.817,0,0,0-2.562-1.22H21.407V24.08a4.177,4.177,0,0,0,1.261,2.888,4.065,4.065,0,0,0,2.888,1.139h.854v.651H12.174v-.651h.854a4,4,0,0,0,2.888-1.139,3.917,3.917,0,0,0,1.261-2.807V-14.846H4.852a3.882,3.882,0,0,0-2.644,1.22,3.8,3.8,0,0,0-1.058,2.685v1.1L.5-9.762v-8.176a19.877,19.877,0,0,0,3.376.773,26.231,26.231,0,0,0,4.434.407H30.234a23.732,23.732,0,0,0,5.288-.488,22.015,22.015,0,0,0,2.6-.691v8.176l-.651-.081Zm0,0",
    transform: "translate(-0.5 17.938)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134",
    transform: "translate(591.939 912.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M2.354,28.082A3.87,3.87,0,0,0,5.2,26.9a4.33,4.33,0,0,0,1.3-2.929V-12.39a3.307,3.307,0,0,0-1.261-2.6,4.181,4.181,0,0,0-2.888-1.1H1.541L1.5-16.742H20.536a28.62,28.62,0,0,0,4.352-.366,16.719,16.719,0,0,0,3.376-.813v8.216h-.651v-1.18a3.61,3.61,0,0,0-1.1-2.644,3.569,3.569,0,0,0-2.563-1.18H10.733V5.344H21.675a3.276,3.276,0,0,0,2.2-.976,3.013,3.013,0,0,0,.935-2.278V1.2h.651v10.25h-.651v-.976a3.024,3.024,0,0,0-.895-2.2A3.207,3.207,0,0,0,21.756,7.3H10.733V26.7h9.274q4.789,0,7.322-2.115a15.647,15.647,0,0,0,4.23-6.386h.651L28.468,28.732H1.5v-.651Zm0,0",
    transform: "translate(-1.5 17.922)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(643.904 913.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M36.1-17.469H49.161v.651h-.61A5.743,5.743,0,0,0,45.378-15.8a7.076,7.076,0,0,0-2.481,3.01L27.278,22.23q-2.441,5.247-2.441,6.671h-.569L6-12.71A6.712,6.712,0,0,0,3.523-15.8,5.974,5.974,0,0,0,.31-16.818H-.219v-.651h14.6v.651h-.569a2.468,2.468,0,0,0-2.074.895,2.72,2.72,0,0,0-.651,1.627,3.722,3.722,0,0,0,.325,1.5L25,21.254,39.155-12.791a4.951,4.951,0,0,0,.244-1.5,2.671,2.671,0,0,0-.691-1.627,2.375,2.375,0,0,0-2.034-.895H36.1Zm0,0",
    transform: "translate(0.219 17.469)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136",
    transform: "translate(715.402 912.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M2.354,28.082A3.87,3.87,0,0,0,5.2,26.9a4.33,4.33,0,0,0,1.3-2.929V-12.39a3.307,3.307,0,0,0-1.261-2.6,4.181,4.181,0,0,0-2.888-1.1H1.541L1.5-16.742H20.536a28.62,28.62,0,0,0,4.352-.366,16.719,16.719,0,0,0,3.376-.813v8.216h-.651v-1.18a3.61,3.61,0,0,0-1.1-2.644,3.569,3.569,0,0,0-2.563-1.18H10.733V5.344H21.675a3.276,3.276,0,0,0,2.2-.976,3.013,3.013,0,0,0,.935-2.278V1.2h.651v10.25h-.651v-.976a3.024,3.024,0,0,0-.895-2.2A3.207,3.207,0,0,0,21.756,7.3H10.733V26.7h9.274q4.789,0,7.322-2.115a15.647,15.647,0,0,0,4.23-6.386h.651L28.468,28.732H1.5v-.651Zm0,0",
    transform: "translate(-1.5 17.922)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137",
    transform: "translate(771.718 912.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_174",
    "data-name": "Group 174",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_173",
    "data-name": "Group 173",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1.616,25.913a24.256,24.256,0,0,1-.163-3.539,17.217,17.217,0,0,1,.976-5.491H3a10.929,10.929,0,0,0-.081,1.424,9.394,9.394,0,0,0,2.4,6.589A8.332,8.332,0,0,0,11.7,27.5a9.43,9.43,0,0,0,6.711-2.441,8.168,8.168,0,0,0,2.644-6.223,7.865,7.865,0,0,0-2.522-6.061L6.049,1.223a10.3,10.3,0,0,1-3.5-7.85A11.13,11.13,0,0,1,5.6-14.518a10.922,10.922,0,0,1,8.379-3.295,27.873,27.873,0,0,1,5.572.651h2.522v7.972h-.569a6.042,6.042,0,0,0-2.115-4.84,8.049,8.049,0,0,0-5.45-1.83,7.576,7.576,0,0,0-5.532,2.2A7.427,7.427,0,0,0,6.171-8.132a7.477,7.477,0,0,0,2.6,5.695L21.587,9.4a10.535,10.535,0,0,1,3.254,8.176,11.571,11.571,0,0,1-3.335,8.542,11.844,11.844,0,0,1-8.826,3.335,22.844,22.844,0,0,1-6.061-.895A10.764,10.764,0,0,1,1.616,25.913Zm0,0",
    transform: "translate(-1.453 17.812)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138",
    transform: "translate(425.375 977.124)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M500.287,101.41H-34.926V95.8H500.287v5.613",
    transform: "translate(-256.124 -98.543)",
    fill: "#d3b175",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(316.356 831.629)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(0 -2.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149",
    transform: "translate(0.102 2.502)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(-0.102 -2.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    transform: "translate(0.641 2.603)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139",
    transform: "translate(0.436 0.201)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M.41,1.074V193.111H84.6V1.074Zm0,0",
    transform: "translate(-0.419 -1.082)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148",
    transform: "translate(-0.102 -2.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(0.641 2.603)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144",
    transform: "translate(0.436 0.201)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_487",
    "data-name": "Path 487",
    d: "M.41,1.074V193.111H84.6V1.074Zm0,0",
    transform: "translate(-0.419 -1.082)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154",
    transform: "translate(337.182 928.05)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153",
    transform: "translate(0.488 0.132)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_492",
    "data-name": "Path 492",
    d: "M43.188,78.051V137.74h37.96V78.051Zm0,0",
    transform: "translate(-43.188 -78.051)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(355.404 883.795)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155",
    transform: "translate(2.38 0.742)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_495",
    "data-name": "Path 495",
    d: "M50.914,61.285V87.673H69.37V61.285Zm0,0",
    transform: "translate(-50.914 -61.285)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158",
    transform: "translate(355.404 909.827)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157",
    transform: "translate(2.39 0.203)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_498",
    "data-name": "Path 498",
    d: "M50.918,71.078V98.432h18.4V71.078Zm0,0",
    transform: "translate(-50.918 -71.078)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(300.33 974.907)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171",
    transform: "translate(-2.197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169",
    transform: "translate(2.196 1.871)",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(-2.196 -1.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160",
    transform: "translate(2.196 2.603)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(0.391 0.885)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M.918,1.34V12.729H31.831V1.34Zm0,0",
    transform: "translate(-1.116 -1.34)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-6)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168",
    transform: "translate(-2.196 -1.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165",
    transform: "translate(2.196 2.603)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164",
    transform: "translate(0.391 0.885)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M.918,1.34V12.729H31.831V1.34Zm0,0",
    transform: "translate(-1.116 -1.34)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-6)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174",
    transform: "translate(337.182 836.938)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173",
    transform: "translate(2.105 1.068)",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M43.809,43.41V90.949H99.3V43.41Zm0,0",
    transform: "translate(-43.809 -43.41)",
    stroke: "#707070",
    strokeWidth: 1,
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(424.935 844.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M-1.818,36.792a11.391,11.391,0,0,0,3.5.569,9.83,9.83,0,0,0,3.579-.732,9.583,9.583,0,0,0,3.457-2.237,11.346,11.346,0,0,0,2.563-4.556A23.159,23.159,0,0,0,12.3,22.6V-12.71a4.2,4.2,0,0,0-1.3-2.888,3.832,3.832,0,0,0-2.847-1.22H7.293v-.651H21.529v.651h-.854a4.078,4.078,0,0,0-2.929,1.18,4.088,4.088,0,0,0-1.22,2.929V22.8a19.98,19.98,0,0,1-1.383,7.728,11.954,11.954,0,0,1-3.457,5,13.587,13.587,0,0,1-8.623,3.051,11.82,11.82,0,0,1-5.125-1.1Zm0,0",
    transform: "translate(2.063 17.469)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(464.667 844.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M45.749-16.818H44.691a3.482,3.482,0,0,0-2.359.895,2.792,2.792,0,0,0-1.058,2.156V11.98a16.259,16.259,0,0,1-4.84,12.243q-4.8,4.683-12.813,4.678-7.977,0-12.935-4.637Q5.714,19.627,5.724,12.021V-13.564a3.014,3.014,0,0,0-1.668-2.847,4.055,4.055,0,0,0-1.79-.407H1.25v-.651H14.429v.651H13.371a3.439,3.439,0,0,0-2.4.895,2.941,2.941,0,0,0-1.017,2.237V11.126q0,7.077,3.783,11.43a12.835,12.835,0,0,0,10.169,4.352A13.664,13.664,0,0,0,34.238,22.8a14.969,14.969,0,0,0,3.986-10.82V-13.686a3.123,3.123,0,0,0-1.057-2.237,3.456,3.456,0,0,0-2.4-.895H33.709v-.651h12.04Zm0,0",
    transform: "translate(-1.25 17.469)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(525.392 844.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M2.354,27.355A3.87,3.87,0,0,0,5.2,26.176a4.33,4.33,0,0,0,1.3-2.929V-12.71A4.2,4.2,0,0,0,5.2-15.6a3.832,3.832,0,0,0-2.847-1.22H1.5v-.651H15.736v.651h-.854A3.93,3.93,0,0,0,11.3-14.784a3.987,3.987,0,0,0-.569,2.074V25.972h9.274q4.789,0,7.322-2.115a15.647,15.647,0,0,0,4.23-6.386h.651L28.468,28.006H1.5v-.651Zm0,0",
    transform: "translate(-1.5 17.469)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178",
    transform: "translate(570.983 844.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M2.354,27.355A3.87,3.87,0,0,0,5.2,26.176a4.33,4.33,0,0,0,1.3-2.929V-12.791a4.159,4.159,0,0,0-1.3-2.847,3.909,3.909,0,0,0-2.847-1.18H1.5v-.651H15.736v.651h-.854a4.078,4.078,0,0,0-2.929,1.18,3.989,3.989,0,0,0-1.22,2.847V23.247a3.994,3.994,0,0,0,1.22,2.929,4.037,4.037,0,0,0,2.929,1.18h.854v.651H1.5v-.651Zm0,0",
    transform: "translate(-1.5 17.469)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(597.553 843.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M46.883,27.906h.529v.651H32.769v-.651h.61a2.472,2.472,0,0,0,2.034-.854,2.8,2.8,0,0,0,.691-1.668,5.034,5.034,0,0,0-.285-1.586L31.671,12.775H14.14l-4.352,11.1a5.158,5.158,0,0,0-.244,1.546,2.817,2.817,0,0,0,.651,1.627,2.5,2.5,0,0,0,2.074.854h.569v.651H-.219v-.651H.351a5.712,5.712,0,0,0,3.173-1.017A7.435,7.435,0,0,0,6.086,23.8L20.77-11.142c1.6-3.5,2.4-5.715,2.4-6.671h.569L41.148,23.8a7.212,7.212,0,0,0,2.481,3.091A5.792,5.792,0,0,0,46.883,27.906ZM14.912,10.823H30.9l-7.81-20.866Zm0,0",
    transform: "translate(0.219 17.812)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(656.384 843.192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M48.715-16.217a3.876,3.876,0,0,0-2.766,1.139,3.972,3.972,0,0,0-1.261,2.766V21.2a50.018,50.018,0,0,0,.488,7.159L45.3,29.5h-.61L9.3-8.285V24.052a3.661,3.661,0,0,0,1.18,2.766,3.877,3.877,0,0,0,2.807,1.139h1.22v.651H1.125v-.651h1.22a3.91,3.91,0,0,0,2.807-1.139,3.739,3.739,0,0,0,1.18-2.807V-9.709a45.84,45.84,0,0,0-.488-7.077l-.122-1.058h.651L41.8,19.984V-12.271a4.093,4.093,0,0,0-1.261-2.807,3.894,3.894,0,0,0-2.766-1.139H36.512v-.651H49.894v.651Zm0,0",
    transform: "translate(-1.125 17.844)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(716.596 843.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M46.883,27.906h.529v.651H32.769v-.651h.61a2.472,2.472,0,0,0,2.034-.854,2.8,2.8,0,0,0,.691-1.668,5.034,5.034,0,0,0-.285-1.586L31.671,12.775H14.14l-4.352,11.1a5.158,5.158,0,0,0-.244,1.546,2.817,2.817,0,0,0,.651,1.627,2.5,2.5,0,0,0,2.074.854h.569v.651H-.219v-.651H.351a5.712,5.712,0,0,0,3.173-1.017A7.435,7.435,0,0,0,6.086,23.8L20.77-11.142c1.6-3.5,2.4-5.715,2.4-6.671h.569L41.148,23.8a7.212,7.212,0,0,0,2.481,3.091A5.792,5.792,0,0,0,46.883,27.906ZM14.912,10.823H30.9l-7.81-20.866Zm0,0",
    transform: "translate(0.219 17.812)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    transform: "translate(691.467 973.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M6.961,3.4,7.988,5.724h.691L4.6-3.57.27,5.724H.981L2.069,3.4Zm-.285-.641H2.364L4.571-2Zm0,0",
    transform: "translate(-0.27 3.57)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(705.084 973.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M.492,5.655H3.136A4.459,4.459,0,0,0,4.946,5.3,4.057,4.057,0,0,0,6.39,4.252a4.551,4.551,0,0,0,.885-1.464A4.889,4.889,0,0,0,7.59,1.049,4.973,4.973,0,0,0,7.275-.69,4.731,4.731,0,0,0,6.39-2.144,4.378,4.378,0,0,0,4.946-3.161a4.464,4.464,0,0,0-1.81-.366H.492Zm.641-.641V-2.877h2A3.676,3.676,0,0,1,5.922-1.707,3.75,3.75,0,0,1,6.675-.446a4.622,4.622,0,0,1,.264,1.495,4.71,4.71,0,0,1-.264,1.525,3.563,3.563,0,0,1-.752,1.241,3.548,3.548,0,0,1-2.786,1.2Zm0,0",
    transform: "translate(-0.492 3.527)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(716.837 973.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M.945-3.527H.254L4.423,5.808l4.19-9.335H7.9L4.423,4.231Zm0,0",
    transform: "translate(-0.254 3.527)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(729.816 973.039)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M8.954,3.47a4.687,4.687,0,0,0,.62-2.349,4.678,4.678,0,0,0-.62-2.339,4.938,4.938,0,0,0-1.7-1.729,4.753,4.753,0,0,0-2.329-.62,4.622,4.622,0,0,0-2.339.62A4.611,4.611,0,0,0,.9-1.238,4.612,4.612,0,0,0,.27,1.121,4.507,4.507,0,0,0,.9,3.481a4.439,4.439,0,0,0,1.688,1.7,4.523,4.523,0,0,0,2.339.641A4.5,4.5,0,0,0,7.245,5.2,4.882,4.882,0,0,0,8.954,3.47ZM8.384-.912a4.141,4.141,0,0,1,.539,2.034,4,4,0,0,1-.539,2.034A3.8,3.8,0,0,1,6.93,4.619a3.8,3.8,0,0,1-2,.549A3.806,3.806,0,0,1,2.913,4.63,4,4,0,0,1,1.459,3.145,3.85,3.85,0,0,1,.91,1.121,3.909,3.909,0,0,1,1.449-.892,4.021,4.021,0,0,1,2.913-2.377a3.9,3.9,0,0,1,2.013-.539,3.882,3.882,0,0,1,1.993.539A4.206,4.206,0,0,1,8.384-.912Zm0,0",
    transform: "translate(-0.27 3.566)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(743.729 973.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M8.537,4.066,8.028,3.68a4.025,4.025,0,0,1-1.393,1.1,3.861,3.861,0,0,1-1.708.4,3.806,3.806,0,0,1-2.013-.539A4,4,0,0,1,1.459,3.151,3.938,3.938,0,0,1,.91,1.117,3.919,3.919,0,0,1,1.449-.906,4.048,4.048,0,0,1,2.913-2.4,3.9,3.9,0,0,1,4.927-2.94a3.978,3.978,0,0,1,1.607.356A4.139,4.139,0,0,1,7.876-1.6l.5-.437A5.088,5.088,0,0,0,6.788-3.164,4.508,4.508,0,0,0,4.927-3.57a4.39,4.39,0,0,0-2.318.63A4.824,4.824,0,0,0,.9-1.232,4.6,4.6,0,0,0,.27,1.117,4.559,4.559,0,0,0,.9,3.477,4.537,4.537,0,0,0,2.588,5.185a4.523,4.523,0,0,0,2.339.641,4.446,4.446,0,0,0,2-.458A4.593,4.593,0,0,0,8.537,4.066Zm0,0",
    transform: "translate(-0.27 3.57)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(756.624 973.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M6.961,3.4,7.988,5.724h.691L4.6-3.57.27,5.724H.981L2.069,3.4Zm-.285-.641H2.364L4.571-2Zm0,0",
    transform: "translate(-0.27 3.57)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(769.661 973.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M8.537,4.066,8.028,3.68a4.025,4.025,0,0,1-1.393,1.1,3.861,3.861,0,0,1-1.708.4,3.806,3.806,0,0,1-2.013-.539A4,4,0,0,1,1.459,3.151,3.938,3.938,0,0,1,.91,1.117,3.919,3.919,0,0,1,1.449-.906,4.048,4.048,0,0,1,2.913-2.4,3.9,3.9,0,0,1,4.927-2.94a3.978,3.978,0,0,1,1.607.356A4.139,4.139,0,0,1,7.876-1.6l.5-.437A5.088,5.088,0,0,0,6.788-3.164,4.508,4.508,0,0,0,4.927-3.57a4.39,4.39,0,0,0-2.318.63A4.824,4.824,0,0,0,.9-1.232,4.6,4.6,0,0,0,.27,1.117,4.559,4.559,0,0,0,.9,3.477,4.537,4.537,0,0,0,2.588,5.185a4.523,4.523,0,0,0,2.339.641,4.446,4.446,0,0,0,2-.458A4.593,4.593,0,0,0,8.537,4.066Zm0,0",
    transform: "translate(-0.27 3.57)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(783.31 973.141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M.559-3.527V5.655H1.2V-3.527Zm0,0",
    transform: "translate(-0.559 3.527)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(789.324 973.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M6.961,3.4,7.988,5.724h.691L4.6-3.57.27,5.724H.981L2.069,3.4Zm-.285-.641H2.364L4.571-2Zm0,0",
    transform: "translate(-0.27 3.57)",
    fill: "#fffcfc",
    stroke: "#707070",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJulianaLogoTransparent);
export default __webpack_public_path__ + "static/media/Juliana-Logo-Transparent.6eded2935535990fbf534b1ba074cef8.svg";
export { ForwardRef as ReactComponent };